import { Button, Modal } from "react-bootstrap";
import { onSuccess, useApiMutation } from "../utils/api";
import { toast } from "react-toastify";
import { SimpleForm } from "../utils/simple_form";
import { ModalBase } from "../utils/modal_launcher";

export const SettingsModal = ({
  board,
  close,
  refetch,
}: {
  board: any;
  close: () => void;
  refetch: () => void;
}) => {
  const { post } = useApiMutation();

  const onSubmit = (data: any) => {
    post(`/api/user/update_board/${board.id}`, { name: data.name }).then(
      onSuccess(() => {
        close();
        refetch();
      })
    );
  };

  const deleteBoard = () => {
    if (
      confirm("Are you sure you want to delete this board? This action cannot be undone.")
    ) {
      post(`/api/user/delete_board/${board.id}`).then(
        onSuccess(() => {
          toast.success("Board was deleted");
          if (board.is_top) {
            window.location.href = "/dashboard";
          } else {
            window.location.href = `/boards/${board.top.id}`;
            close();
          }
        })
      );
    }
  };

  return (
    <ModalBase title="Settings" close={close}>
      <Modal.Body>
        <SimpleForm
          onSubmit={onSubmit}
          data={board}
          fields={{
            name: { required: true },
          }}
        />

        {board.is_owner && (
          <>
            <hr />
            <ManageShares board={board} refetch={refetch} />
            <hr />
            <div className="mb-3">
              <Button variant="link" className="text-danger p-0" onClick={deleteBoard}>
                Delete this board
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
    </ModalBase>
  );
};

const ManageShares = ({ board, refetch }) => {
  const { post, saving } = useApiMutation();

  const share = (friend) => {
    post(`/api/user/share_board/${board.top.id}`, {
      friend_id: friend.id,
    }).then(
      onSuccess(() => {
        toast.success(`Board shared with ${friend.name}`);
        refetch();
      })
    );
  };

  const unshare = (friend) => {
    if (!confirm("Unshare with this friend?")) {
      return;
    }

    post(`/api/user/unshare_board/${board.top.id}`, {
      friend_id: friend.id,
    }).then(
      onSuccess(() => {
        toast.success(`Board unshared with ${friend.name}`);
        refetch();
      })
    );
  };

  return (
    <>
      <div className="fs-18 fw-bold mb-2 underline">Share</div>
      {board.share_status.length === 0 && (
        <div className="fs-13">No friends added yet</div>
      )}

      <div className="mt-2 mb-1 fs-13">
        {board.share_status.map((friend) => (
          <div
            key={friend.id}
            className="d-flex align-items-center justify-content-between fs-13"
          >
            {friend.name}
            <div>
              {friend.shared ? (
                <div className="d-flex align-items-center">
                  Shared
                  <button
                    className="btn btn-link fs-13 red ml-2"
                    onClick={() => unshare(friend)}
                    disabled={saving}
                  >
                    <i className="bi bi-x fs-16"></i>
                  </button>
                </div>
              ) : (
                <button
                  className="btn btn-link fs-13"
                  onClick={() => share(friend)}
                  disabled={saving}
                >
                  Share
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
